module.exports = __webpack_public_path__ + "fonts/Roboto-Light.333da16.ttf";